'use client';

import CloseIcon from '@hc-frontend/core-icons/kit/cancel';
import { Link } from '@hc-frontend/core-ui';
import { usePathname, useSearchParams } from 'next/navigation';

import type { FilterChipProps } from './filter-chip.types';

/**
 * Renders a "chip" that removes the filter when clicked.
 */
export function FilterChip({
  filter: { name, label, value },
}: FilterChipProps) {
  const searchParams = useSearchParams();
  const pathname = usePathname();

  const filterId = `${name}-${value}-chip`;
  const params = new URLSearchParams(searchParams.toString());

  const buildFilterLink = () => {
    params.delete(name, value);
    return `${pathname}?${params.toString()}`;
  };

  const link = buildFilterLink();

  return (
    <div className="flex w-fit items-center gap-8-8 rounded-full border border-tertiary-900 p-2-2 pl-8-8">
      <span className="hc-typography--help-text font-bold leading-none text-tertiary-900">
        {label ?? value}
      </span>
      <Link
        id={`${filterId}-link`}
        href={link}
        prefetch={false}
        className="flex size-24-24 items-center justify-center rounded-full bg-gray-0"
        replace
      >
        <CloseIcon className="size-24-24 font-bold text-tertiary-900" />
      </Link>
    </div>
  );
}
